const PageStatistics = [
	{
		id: 1,
		link: '/',
		exits: 32,
		views: 1243
	},
	{
		id: 2,
		link: '/landings/courses.html',
		exits: 26,
		views: 943
	},
	{
		id: 3,
		link: '/landings/lead.html',
		exits: 22,
		views: 856
	},
	{
		id: 4,
		link: '/dashboard.html',
		exits: 18,
		views: 621
	},
	{
		id: 5,
		link: '/checkout.html',
		exits: 14,
		views: 316
	},
	{
		id: 6,
		link: '/blog.html',
		exits: 9,
		views: 253
	}
];

export default PageStatistics;
